<div class="home-top-bar">
  <mat-toolbar>
    @if (showBackButton | async) {
      <button mat-button color="primary" class="back-button" (click)="navigateBack()">
        <mat-icon>keyboard_arrow_left</mat-icon>
        @if (!navigate.xSmall) {
          <span>{{ "ONSIP_I18N.BACK" | translate }}</span>
        }
      </button>
    }
    <div class="page-step-title onsip-signup-headline">
      {{ "ONSIP_I18N.STEP" | translate }} {{ currentStepNumber | async }}
      {{ "ONSIP_I18N.OF" | translate }} {{ totalStep }}
      @if (!navigate.xSmall) {
        <div>: {{ displayTitle | async }}</div>
      }
    </div>
  </mat-toolbar>
  <mat-progress-bar
    color="accent"
    mode="determinate"
    [value]="progressBar | async"
  ></mat-progress-bar>
</div>
<div id="onsip-signup" class="body mat-typography">
  <router-outlet></router-outlet>
</div>
